export enum STORAGE {
  Theme_key = '@kothe:theme',
  Current_screen = 'current-screen',
  Submenu = 'submenu',
}
